import { MutableRefObject, useEffect, useRef } from 'react';

import { Optional } from '@vimeo/core/types/generic';

/**
 * Keep props/state value between renders
 */
export function usePreviousValue<T>(value: T): T {
  const ref: MutableRefObject<Optional<T | null> | null> = useRef<T>(null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current as T;
}
